import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@aws-amplify/ui-react";

const UserInfoTable = (props) => {

  // 表示用のテキストを生成
  const getSubscriptionText = () => {
    const status = props.userinfo["custom:subscription_status"];
    const isCancelPending = props.userinfo["custom:subscription_cancel"] === "true";
    const endDateStr = props.userinfo["custom:subscription_enddate"];

    if (status === "active") {
      if (isCancelPending && endDateStr) {
        // 日付を「2026/4/10」形式に変換
        const formattedDate = new Date(endDateStr).toLocaleDateString("ja-JP");
        return `利用中（${formattedDate}に終了）`;
      }
      return "利用中";
    }

    return "利用していない";
  };

  return (
    <Table caption="" highlightOnHover={false} size="small" variation="striped">
      <TableHead></TableHead>
      <TableBody>
        <TableRow>
          <TableCell>名前</TableCell>
          <TableCell>{props.userinfo.name}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>会社名・所属</TableCell>
          <TableCell>{props.userinfo["custom:company"]}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>部署</TableCell>
          <TableCell>{props.userinfo["custom:department"]}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>役職</TableCell>
          <TableCell>{props.userinfo["custom:director"]}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>所在地・住所</TableCell>
          <TableCell>{props.userinfo.address}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>電話番号</TableCell>
          <TableCell>{props.userinfo["custom:tel"]}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>利用用途</TableCell>
          <TableCell>{props.userinfo["custom:purposeofuse"]}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>メールアドレス</TableCell>
          <TableCell>{props.userinfo.email}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>各種案内のメール</TableCell>
          <TableCell>
            {props.userinfo["custom:marketingmailreceive"] === "true"
              ? "受け取る"
              : "受け取らない"}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>サブスクリプション</TableCell>
          <TableCell>
            {getSubscriptionText()}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default UserInfoTable;
